// Dobra de acentos no cliente (T1/§7.1) — mesma técnica de normalizeName em
// backend/src/importer/parseTeam.js:39-47. Usada nos filtros locais (coluna
// de pessoa, menções); a busca no servidor (GET /users/search) usa translate()
// em SQL (backend/src/utils/searchFold.js), que cobre um conjunto de caracteres
// equivalente mas não idêntico byte a byte — ambos tratam PT-BR/ES/FR.
//
// Faixa Unicode das marcas combinantes (U+0300 a U+036F), construída por
// código (não por escape de regex no texto-fonte) para evitar qualquer
// ambiguidade de transcrição do caractere no arquivo.
const COMBINING_MARKS_START = String.fromCharCode(0x0300);
const COMBINING_MARKS_END = String.fromCharCode(0x036f);
const COMBINING_MARKS_RE = new RegExp(`[${COMBINING_MARKS_START}-${COMBINING_MARKS_END}]`, 'g');

export function foldText(s) {
  return String(s ?? '')
    .normalize('NFD')
    .replace(COMBINING_MARKS_RE, '')
    .toLowerCase();
}
